// extracted by mini-css-extract-plugin
export default {"global-layout":"GlobalLayout_global-layout__UkYKt"};